module.exports = __webpack_public_path__ + "img/samlinger_960px.9fd6b98d.jpg";